<div class="gray-bg-rounded">
  <ng-container [formGroup]="parent">
    <ng-container formGroupName="lines">
      <h3 class="mb-2">Line detail</h3>
      <div class="row">
        <div class="col-4 mb-2" [hidden]="orderType === 'inventory-sales'">
          <div class="form-group has-float-label">
            <label class="form-label">Vendor SKU</label>
            <input
              pInputText
              [jniPrefixFocusAndSelect]="
                addNewLineCase === false ? true : false
              "
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              placeholder=""
              formControlName="externalItemNumberD365"
              (focusout)="applyVendorSkuLengthValidation($event)" />
          </div>
        </div>
        <div class="col-4 mb-2">
          <!-- <div
          class="form-group has-float-label"
          [hidden]="orderType !== 'inventory-sales'"
        >
          <ng-select
            class="p-0"
            id="currency"
            formControlName="itemNumberD365"
            [ngClass]="{ 'has-error': formErrors.itemNumberD365 }"
            (blur)="logValidationErrors()"
            (change)="itemSelected($event)"
          >
            <ng-option *ngFor="let com of filteredReleasedProductsList" [value]="com">
              {{ com }}
            </ng-option>
          </ng-select>
          <label class="form-label">{{ labelType }}<span class="madatory-field">*</span></label>
          <span class="error-msg" *ngIf="formErrors.itemNumberD365">
            {{ formErrors.itemNumberD365 }}
          </span>
        </div> -->
          <div class="form-group has-float-label">
            <label class="form-label"
              >{{ labelType }}<span class="madatory-field">*</span></label
            >
            <p-select
              id="currency"
              formControlName="itemNumberD365"
              [ngClass]="{ 'has-error': formErrors['itemNumberD365'] }"
              (blur)="logValidationErrors()"
              (onChange)="itemSelected($event, salesOrderLine?.lineRecIdD365)"
              tabindex="2"
              [options]="filteredReleasedProductsList"
              optionLabel="itemNumberD365"
              optionValue="itemNumberD365"
              [filter]="true"
              [showClear]="true">
            </p-select>

            <span class="error-msg" *ngIf="formErrors['itemNumberD365']">
              {{ formErrors["itemNumberD365"] }}
            </span>
          </div>
        </div>
        <div class="col-4 mb-2" [hidden]="orderType === 'inventory-purchase'">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Sales Classification<span class="madatory-field">*</span></label
            >
            <p-select
              id="currency"
              formControlName="salesClassificationD365"
              [ngClass]="{ 'has-error': formErrors['salesClassificationD365'] }"
              (blur)="logValidationErrors()"
              tabindex="3"
              (keydown.Tab)="changeFocusToQuantity()"
              [options]="salesClasssificationList"
              optionLabel="name"
              optionValue="value">
            </p-select>

            <span
              class="error-msg"
              *ngIf="formErrors['salesClassificationD365']">
              {{ formErrors["salesClassificationD365"] }}
            </span>
          </div>
        </div>

        <div
          class="col-6 mb-2"
          [hidden]="
            orderType === 'all-sales' || orderType === 'inventory-purchase'
          ">
          <div class="form-group has-float-label flex-grow-1">
            <label class="form-label">{{
              orderType === "inventory-sales" ? "Product Name" : "Category Name"
            }}</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="categoryName" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mb-2 d-flex gap-3">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Quantity <span class="madatory-field">*</span></label
            >
            <input
              pInputText
              #orderedPurchaseQuantityD365
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="orderedPurchaseQuantityD365"
              (focusout)="onQuantityChange($event)"
              [ngClass]="{
                'has-error': formErrors['orderedPurchaseQuantityD365'],
              }"
              (blur)="logValidationErrors()"
              tabindex="4" />

            <span
              class="error-msg"
              *ngIf="formErrors['orderedPurchaseQuantityD365']">
              {{ formErrors["orderedPurchaseQuantityD365"] }}
            </span>
          </div>

          <div class="form-group has-float-label flex-grow-1">
            <label class="form-label">Net Currency</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              #currencySelect
              class="form-control"
              type="text"
              id="currency"
              formControlName="currencyCodeD365"
              (change)="onCurrencyConversion()"
              [disabled]="true"
              [ngModel]="isoCurrencyCode" />
          </div>
          <div class="form-group switcher">
            <label class="form-label d-block l-height mb-2 mt-1"
              >Trackable</label
            >
            <div
              class="form-check form-switch d-flex align-items-center m-0 gap-2">
              <p-toggleswitch
                type="checkbox"
                id="trackable"
                name="trackable"
                formControlName="isTrackable"
                [disabled]="
                  salesOrderLine.itemNumberD365?.toLowerCase() === 'set up' ||
                  salesOrderLine.itemNumberD365?.toLowerCase() === 'setup' ||
                  salesOrderLine.lineStatusD365?.toLowerCase() === 'invoiced' ||
                  salesOrderLine.lineStatusD365?.toLowerCase() === 'delivered'
                " />
              <label class="form-check-label" for="trackable">
                {{ this.parent.get(["lines", "isTrackable"])?.value }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-6 mb-2" [hidden]="orderType === 'inventory-purchase'">
          <div class="form-group has-float-label">
            <label class="form-label">Tracking Nickname</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              placeholder=""
              formControlName="nickName"
              (focusout)="applyNickNameLengthValidation($event)"
              tabindex="5" />
          </div>
        </div>

        <div class="col-6 mb-2 d-flex align-items-center">
          <!-- Hide as per the ticket 11475 -->
          <input
            pInputText
            *ngIf="false"
            type="checkbox"
            class="form-check-input me-2 no-bg"
            formControlName="isnetInForeignCurrencyStatus"
            [disabled]="this.userBlockedFromEdit || this.isFromCdi"
            (click)="onCurrencyEnable($event)" />
        </div>
        <div
          class="col-6 mb-2"
          [hidden]="orderType === 'inventory-purchase'"></div>

        <div class="col-6" *ngIf="orderType === 'inventory-purchase'">
          <div class="form-group switcher">
            <label class="form-label d-block l-height mb-0">Final</label>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <label class="form-check-label" for="trackable">
                {{ this.parent.get(["lines", "final"])?.value }}
              </label>
              <input
                pInputText
                class="form-check-input me-2"
                type="checkbox"
                id="trackable"
                name="trackable"
                formControlName="final" />
            </div>
          </div>
        </div>
        <div class="col-6" *ngIf="orderType === 'inventory-purchase'">
          <div class="form-group switcher">
            <label class="form-label d-block l-height mb-0">Excluded</label>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <label class="form-check-label" for="trackable">
                {{ this.parent.get(["lines", "excluded"])?.value }}
              </label>
              <input
                pInputText
                class="form-check-input me-2"
                type="checkbox"
                id="trackable"
                name="trackable"
                formControlName="excluded" />
            </div>
          </div>
        </div>
        <div
          class="col-6 mb-2"
          [hidden]="
            orderType === 'all-sales' || orderType === 'inventory-purchase'
          ">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Color<span class="madatory-field">*</span></label
            >
            <p-select
              id="currency"
              formControlName="color"
              [ngClass]="{ 'has-error': formErrors['color'] }"
              (onChange)="colorSelected()"
              (blur)="logValidationErrors()"
              [options]="filteredColors">
            </p-select>

            <span class="error-msg" *ngIf="formErrors['color']">
              {{ formErrors["color"] }}
            </span>
          </div>
        </div>
        <div
          class="col-6 mb-2"
          [hidden]="
            orderType === 'all-sales' || orderType === 'inventory-purchase'
          ">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Size<span class="madatory-field">*</span></label
            >
            <p-select
              id="currency"
              formControlName="size"
              [ngClass]="{ 'has-error': formErrors['size'] }"
              (onChange)="sizeSelected()"
              (blur)="logValidationErrors()"
              [options]="filteredSizes">
            </p-select>

            <span class="error-msg" *ngIf="formErrors['size']">
              {{ formErrors["size"] }}
            </span>
          </div>
        </div>
        <div
          class="col-6 mb-2"
          [hidden]="
            orderType === 'all-sales' || orderType === 'inventory-purchase'
          ">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Style<span class="madatory-field">*</span></label
            >
            <p-select
              id="currency"
              formControlName="style"
              [ngClass]="{ 'has-error': formErrors['style'] }"
              (onChange)="styleSelected()"
              (blur)="logValidationErrors()"
              [options]="filteredStyles">
            </p-select>

            <span class="error-msg" *ngIf="formErrors['style']">
              {{ formErrors["style"] }}
            </span>
          </div>
        </div>
        <div class="col-6 mb-2" [hidden]="true">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Config<span class="madatory-field">*</span></label
            >
            <p-select
              id="currency"
              formControlName="config"
              [ngClass]="{ 'has-error': formErrors['config'] }"
              (onChange)="configSelected()"
              (blur)="logValidationErrors()"
              [options]="filteredConfigs">
            </p-select>

            <span class="error-msg" *ngIf="formErrors['config']">
              {{ formErrors["config"] }}
            </span>
          </div>
        </div>
        <div
          class="col-6 mb-2"
          [hidden]="
            orderType === 'all-sales' || orderType === 'inventory-purchase'
          ">
          <div class="form-group has-float-label">
            <label class="form-label"
              >Warehouse
              <span
                class="madatory-field"
                *ngIf="orderType === 'inventory-sales'"
                >*</span
              ></label
            >
            <p-select
              formControlName="warehouse"
              [options]="filteredWarehouseList"
              optionLabel="warehouseIdD365"
              optionValue="warehouseIdD365"
              [filter]="true"
              [showClear]="true"
              placeholder="Select Warehouse"
              [ngClass]="{ 'has-error': formErrors['warehouse'] }"
              (onChange)="warehouseSelected()"
              (blur)="logValidationErrors()">
            </p-select>
            <span class="error-msg" *ngIf="formErrors['warehouse']">
              {{ formErrors["warehouse"] }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col mb-2" [hidden]="orderType === 'inventory-purchase'">
          <div class="row">
            <div class="col-6 has-icon">
              <div class="form-group has-float-label">
                <label class="form-label">Sell</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    sellRateValueWithIcon
                      | currency: sellIsoCurrencyCode : 'symbol' : '0.3-3'
                  "
                  (focusout)="onSellConversion($event)"
                  [disabled]="sellRateValueWithIconStatus"
                  tabindex="6" />
              </div>
            </div>
            <div class="col-6">
              <div
                class="form-group has-float-label"
                *ngIf="sellCurrencyStatus">
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    sellConvertToUsd | currency: 'USD' : 'symbol' : '0.3-3'
                  "
                  disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 mb-2">
          <div class="row">
            <div class="col has-icon">
              <div class="form-group has-float-label">
                <label class="form-label">NET</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    netValueWithIcon
                      | currency: isoCurrencyCode : 'symbol' : '0.5-5'
                  "
                  (focusout)="onNetConversion($event)"
                  [disabled]="
                    !userBlockedFromEdit ||
                    (orderLineNumber &&
                    salesOrderLine.deliverRemainderD365 !== null
                      ? salesOrderLine.deliverRemainderD365 === 0
                      : salesOrderLine.orderedPurchaseQuantityD365 === 0) ||
                    orderType === 'inventory-sales' ||
                    disableNetIfVendorNotfound()
                  "
                  tabindex="7" />
              </div>
            </div>
            <div class="col">
              <div
                class="form-group has-float-label"
                *ngIf="showForeignCurrency">
                <label class="form-label"></label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    netConvertToUsd | currency: 'USD' : 'symbol' : '0.4-4'
                  "
                  disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col mb-2" [hidden]="orderType === 'inventory-purchase'">
          <div class="row">
            <div class="col has-icon">
              <div class="form-group has-float-label">
                <label class="form-label">Sell Total</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    sellTotalPrice
                      | currency: sellIsoCurrencyCode : 'symbol' : '1.2-2'
                  "
                  disabled />
              </div>
            </div>
            <div class="col">
              <div
                class="form-group has-float-label"
                *ngIf="sellCurrencyStatus">
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    sellTotalPriceConverted
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  "
                  disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="col mb-2">
          <div class="row">
            <div class="col has-icon">
              <div class="form-group has-float-label">
                <label class="form-label">Net Total</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    netTotalPrice
                      | currency: isoCurrencyCode : 'symbol' : '1.2-2'
                  "
                  disabled />
              </div>
            </div>
            <div class="col">
              <div
                class="form-group has-float-label"
                *ngIf="showForeignCurrency">
                <label class="form-label"></label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  [value]="
                    netTotalPriceConverted
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  "
                  disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" [hidden]="orderType === 'inventory-purchase'">
        <div class="col">
          <div class="form-group has-float-label" *ngIf="showCommissionsFields">
            <label class="form-label">Commission</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              [value]="commission | currency: 'USD'"
              disabled />
          </div>
        </div>
        <div class="col">
          <div class="form-group has-float-label">
            <label class="form-label">Gross Profit %</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              [value]="grossProfit"
              disabled />
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<div class="p-d-flex p-flex-column p-ai-center">
  <p-dialog
    appendTo="body"
    [modal]="true"
    [(visible)]="showWarningCategoryChangedDialog">
    <ng-template pTemplate="header">
      <div class="inline-flex items-center justify-center gap-2">
        <span
          class="font-bold whitespace-nowrap"
          style="font-size: 21px; font-weight: bold"
          >Warning
        </span>
        <i class="pi pi-exclamation-triangle"></i>
      </div>
    </ng-template>

    <div class="p-fluid p-dir-col p-p-3">
      <div class="p-field p-mb-2 field-wrap">
        <label
          class="text-bold matchMode form-group has-float-label mb-1"
          style="font-size: 15px"
          >Changing the category on a confirmed line might clear some existing
          data.</label
        >
      </div>
      <div
        class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
        <button
          class="btn btn-secondary"
          type="button"
          (click)="okCategoryChangedDialog()">
          Ok
        </button>
      </div>
    </div>
  </p-dialog>
</div>
